/* eslint-disable max-len */
import { EventEmitter, Injectable } from '@angular/core';
import { ModalService } from '@core/services/modal/modal.service';
import { InformationModalComponent, InformationModalId } from '@shared/components/information/information.modal';
import moment from 'moment';
import { Subject } from 'rxjs';
import { LibraryService } from '../library/library.service';
import { INFORMATION_MODAL_SECTIONS } from '@core/constants';

@Injectable({
    providedIn: 'root'
})
export class InformationModalService {
    private btnClick = new EventEmitter();

    constructor(
        private library: LibraryService,
        private modalService: ModalService
    ) {
    }

    /**
     * Abre un modal de información genérico. Los textos se han de pasar ya traducidos
     * @param headerTitle Texto de cabecera
     * @param label Texto principal
     * @param description Descripción
     * @param icon Nombre del icono
     * @param btnText Texto del botón
     * @param color Tema del botón (Revisar el archivo scss del componente para ver los temas)
     * @returns Modal
     */
    async openGenericModal(headerTitle: string, label: string, description: string, icon: string, btnText: string, color: string, section: string): Promise<HTMLIonModalElement> {
        const modal = await this.modalService.create({
            component: InformationModalComponent,
            componentProps: {
                headerTitle,
                label,
                description,
                icon,
                btnText,
                color,
                section
            },
            id: InformationModalId,
            canDismiss: false,
        });

        await modal.present();

        return modal;
    }

    /**
     * Abre el modal de Firma correcta
     * @returns Modal
     */
    async openSignedSuccessModal(): Promise<HTMLIonModalElement> {
        const modal = await this.modalService.create({
            component: InformationModalComponent,
            componentProps: {
                headerTitle: this.library.getLabel('lbl_doctor_client_sign'),
                label: this.library.getLabel('lbl_info_signed_ok'),
                description: this.getSignedDateString(this.library.getLabel('lbl_info_signed_date')),
                icon: 'check_square',
                btnText: this.library.getLabel('lbl_save'),
                color: 'success',
                section: INFORMATION_MODAL_SECTIONS.SUCCESS_SIGN
            },
            id: InformationModalId,
            canDismiss: false,
        });

        await modal.present();

        return modal;
    }

    /**
     * Emite el event de btnClick
     * @param section sección que ha realizado la llamada
     */
    emitInformationBtnClick(section: string) {
        this.btnClick.emit(section);
    }

    /**
     * Suscripción para recoger los eventos de btnClick
     * @returns Un observable que devuelve un string de la sección
     */
    listenInformationBtnClick() {
        return this.btnClick.asObservable();
    }

    /**
     * Reemplaza ###1### por la fecha de hoy en formato DD/MM/YYYY
     * @param label Label en la cuál se debe reemplazar el texto
     * @returns texto reemplazado
     */
    private getSignedDateString(label){
        return label.replace('###1###', moment().format('DD/MM/YYYY'));
    }
}
